// export const baseUrl = 'http://127.0.0.1:5000/'
export const baseUrl = 'https://dirilis-kutuphane-api.camiakademi.com/'
